export const apiUrl = process.env.REACT_APP_INVIFO_API_URL
export const commUrl = process.env.REACT_APP_INVIFO_COMM_URL
